<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Delivery Reports(Analytics)</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item"><a href="/">Reports</a>
                            </li>
                            <li class="breadcrumb-item">Delivery Reports
                            </li>
                            <li class="breadcrumb-item active">Analytics
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-body">
                    <div class="d-flex justify-content-center mt-2 mb-2 row">
                        <div class="col-md-6 col-xl-6 col-sm-12 col-xs-12">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="col-xl-12 col-md-12 col-xs-12"><label>Start date</label><br>
                                        <date-time-field required="required" class="form-control" v-model="from" bound="start"></date-time-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-12 col-md-12 col-xs-12"><label>&nbsp;</label><br>
                                <button type="submit" class="btn btn-primary" @click="getReport">Filter</button>
                                <button type="button" class="btn btn-default" @click="resetFilter">Reset</button>
                            </div>
                        </div>

                        <div class="col-md-6 col-xl-6 col-sm-12 col-xs-12">
                            <div class="col-xl-12 col-md-12 col-xs-12 mt-1"><label>End date</label><br>
                                <date-time-field required="required" class="form-control" v-model="to" bound="end"></date-time-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 d-flex">
                        <download-excel type="csv" :data="formattedData" :name="'Sales Report(Platforms).csv'"
                                        :sheet-name="'Report'">
                            <a href="#"
                               class="export-link">
                                <i class="fas fa-file-csv"></i> Export to CSV</a> | &nbsp;
                        </download-excel>
                        <download-excel :data="formattedData" :name="'Sales Report(Platforms).xls'">
                            <a href="#" class="export-link text-warning">
                                <i class="fa fa-file-excel-o"></i> Export to Excel</a>
                        </download-excel>
                    </div>
                    <BarChart :chart-data="reportData" :chart-options='{responsive: true}'/>
                </div>
            </section>

            <section class="card">
                <div class="card-body">
                    <div class="d-flex justify-content-center mt-2 mb-2 row">
                        <div class="col-md-6 col-xl-6 col-sm-12 col-xs-12">
                            <div class="col-md-12">
                                <div class="form-group"><label>Choose State</label><br>
                                    <select class="form-control" v-model="state">
                                        <option value="">All states</option>
                                        <option v-for="state in states" :value="state.id" :key="state.id">
                                            {{ state.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-xl-12 col-md-12"><label>Status</label><br>
                                <select class="form-control" v-model="status">
                                    <option value="">Select Status</option>
                                    <option v-for="status in statuses" :key="status"
                                            :value="status">
                                        {{ status }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-xl-12 col-md-12 col-xs-12"><label>&nbsp;</label><br>
                                <button type="submit" class="btn btn-primary" @click="getReport">Filter</button>
                                <button type="button" class="btn btn-default" @click="resetFilter">Reset</button>
                            </div>
                        </div>

                        <div class="col-md-6 col-xl-6 col-sm-12 col-xs-12">
                            <div class="col-xl-12 col-md-12 col-xs-12"><label>Start date</label><br>
                                <date-time-field required="required" class="form-control" v-model="from" bound="start"></date-time-field>
                            </div>

                            <div class="col-xl-12 col-md-12 col-xs-12 mt-1"><label>End date</label><br>
                                <date-time-field required="required" class="form-control" v-model="to" bound="end"></date-time-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 d-flex">
                        <download-excel type="csv" :data="formattedData" :name="'Sales Report(Platforms).csv'"
                                        :sheet-name="'Report'">
                            <a href="#"
                               class="export-link">
                                <i class="fas fa-file-csv"></i> Export to CSV</a> | &nbsp;
                        </download-excel>
                        <download-excel :data="formattedData" :name="'Sales Report(Platforms).xls'">
                            <a href="#" class="export-link text-warning">
                                <i class="fa fa-file-excel-o"></i> Export to Excel</a>
                        </download-excel>
                    </div>
                    <BarChart :chart-data="reportData" :chart-options='{responsive: true}'/>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2';
import BarChart from "../../../Shared/BarChart";

export default {
    metaInfo: {title: 'Platform Reports'},
    props: [
        'platformReports',
        'states',
        'statuses',
    ],
    layout: Layout,
    name: 'platformReport',
    components: {
        BarChart,
        Link,
    },
    mixins: [],
    data: () => ({
        from: null,
        to: null,
        status: '',
        state: '',
        reportData: null,
        excelData: {},
    }),
    mounted() {
        this.excelData = this.platformReports;
        this.reportData = this.generateReportDataset(this.platformReports);
    },

    methods: {

        generateReportDataset(report) {
            let reportData = {
                labels: [],
                datasets: [],
            }

            let data = []

            for (const key in report) {
                reportData.labels.push(key);
                data.push(report[key]);
            }
            reportData.datasets.push({
                label: 'Sales Reports',
                backgroundColor: '#00B5B8',
                data
            })
            return reportData;
        },

        async getReport() {
            try {
                let routeName = 'admin.reports.sales.platform';

                let response = await axios.get(route(routeName), {
                    params: {
                        from: this.from,
                        to: this.to,
                        status: this.status,
                        state: this.state,
                        api: true,
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.excelData = response.data.platformReports;
                this.reportData = this.generateReportDataset(response.data.platformReports);

            } catch (e) {
                console.log(e);
            }
        },

        async resetFilter() {
            this.from = null;
            this.to = null;
            this.status = '';
            this.state = '';
            await this.getReport();
        },

    },
    computed: {
        formattedData() {
            const rows = [];

            // Create a row for column headers
            rows.push(['Device', 'Total']);

            // Add rows for each key-value pair in reportData
            for (const key in this.excelData) {
                rows.push([key, this.excelData[key]]);
            }

            return rows;
        }
    }
}
</script>
